import './lib/foundation-explicit-pieces';

$(document).ready(function(){
	$(document).foundation();
});

